import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QuantityInput from './QuantityInput';
import { useAtomValue } from 'jotai';
import { MoveToToggleMenu, fToCurrency, useParameters } from '@web/utils';
import { cartAtom } from '@/store/atoms';
import { OrderDelivery, OrderItem } from '@/store/types';
import { Location } from '@/types';

interface SingleDelieryItemProps {
  item: OrderItem;
  handleCheckboxChange: (item: OrderItem) => void;
  delivery: OrderDelivery;
  selectedLocations: Location[][];
  handleMoveItem: (toid: string | null) => void;
  handleDeleteItems: () => void;
  canMoveToSilo: boolean;
}

const SingleDeliveryItem = (props: SingleDelieryItemProps) => {
  const {
    item,
    handleCheckboxChange,
    delivery,
    handleMoveItem,
    selectedLocations,
    handleDeleteItems,
    canMoveToSilo,
  } = props;
  const [toggleMenu, setToggleMenu] = useState(false);
  const cart = useAtomValue(cartAtom);
  const { retailerId } = useParameters<{ retailerId: string }>();
  const { t } = useTranslation();

  const handleDotsClick = () => {
    handleCheckboxChange(item);
    setToggleMenu((prev) => !prev);
  };

  return (
    <div
      key={item.inventoryID}
      className="py-3-0 md:py-1-0 border-b last:border-0 border-secondary-grey flex flex-col md:flex-row  items-start md:items-center relative"
    >
      <div className="md:w-1/3 flex items-center mb-2-0 md:mb-0 pr-3-0 md:pr-0">
        <p className="text-2-0 md:text-1-4 font-bd md:max-w-[250px]">
          {item.name}
        </p>
      </div>

      <div className="md:w-1/3">
        <QuantityInput item={item} delivery={delivery} />
      </div>
      <div className="ml-auto pr-10-0">
        <span className="text-body1 font-bd">
          {!item.price ? '*' : fToCurrency(item.lineTotalNet || 0)}
        </span>
      </div>
      <div
        className="absolute right-0-5 top-3-0 flex flex-col px-1-0 cursor-pointer"
        data-testid={`moveToToggleMenu-${item.inventoryID}`}
        onClick={handleDotsClick}
      >
        <div className="bg-primary-black w-0-5 h-0-5 rounded-full mb-0-5"></div>
        <div className="bg-primary-black w-0-5 h-0-5 rounded-full mb-0-5"></div>
        <div className="bg-primary-black w-0-5 h-0-5 rounded-full mb-0-5"></div>
        {toggleMenu && (
          <MoveToToggleMenu
            setIsOpened={setToggleMenu}
            handleMoveItem={handleMoveItem}
            selectedLocations={selectedLocations}
            delivery={delivery}
            selectedCart={cart[retailerId]}
            handleDeleteItems={handleDeleteItems}
            t={t}
            canMoveToSilo={canMoveToSilo}
          />
        )}
      </div>
    </div>
  );
};

export default SingleDeliveryItem;
